import React from 'react'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { Checkbox } from 'primereact/checkbox'
import { Color, LuxButton, LuxIcon, LuxRichInputText } from '@lux/wardrobe-lib'
import './RedoItem.scss'
import { ProjectsService } from '@/app/services/ProjectsService'

const RedoItem = (props: {
    item: {
        value: any
        saved: any
        opened: boolean
        checked: boolean
    }
    setItem: (item) => void
    checkboxLabel: string
}) => {
    const { item, setItem, checkboxLabel } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-redo-item'

    const stripTagsFroala = (str: string) => {
        let stripTags = str.replace(/(<([^>]+)>)/gi, '')
        let stripFroala = stripTags.replace('Powered by Froala Editor', '')
        return stripFroala
    }

    return (
        <div className={`${componentClass}`}>
            <div id="checkbox-1" className={`${componentClass}__checkbox`}>
                <Checkbox
                    inputId="1"
                    checked={item.checked}
                    onChange={(e) => setItem({ ...item, checked: e.checked })}
                />
                <label htmlFor="1" onClick={() => setItem({ ...item, checked: !item.checked })}>
                    {checkboxLabel}
                </label>
                {item.checked && (
                    <>
                        {item.saved && !item.opened && (
                            <div className={`${componentClass}__saved`}>
                                <div className={`${componentClass}__saved__title`}>
                                    {stripTagsFroala(item.saved)}
                                </div>
                                <div className={`${componentClass}__saved__actions`}>
                                    <LuxIcon
                                        icon="pencil"
                                        color={Color.BLUE}
                                        onClick={() => {
                                            setItem({
                                                ...item,
                                                value: item.saved,
                                                opened: true,
                                            })
                                        }}
                                    />
                                    <LuxIcon
                                        icon="trash"
                                        color={Color.BLUE}
                                        onClick={() =>
                                            setItem({
                                                ...item,
                                                saved: '',
                                                opened: true,
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        )}
                        {item.opened && (
                            <>
                                <LuxRichInputText
                                    value={item.value}
                                    onChangeCallback={(value: any) => {
                                        setItem({ ...item, value: value })
                                    }}
                                    placeholder={intl.formatMessage({
                                        id: 'modals.new.activity.section.main.info.rich.text.input.placeholder',
                                        defaultMessage: 'Type here',
                                    })}
                                    fileUploadUrl={ProjectsService.FROALA_UPLOAD_URL}
                                />
                                <LuxButton
                                    text={intl.formatMessage({
                                        id: 'modals.new.activity.section.save',
                                        defaultMessage: 'Save',
                                    })}
                                    variant="text"
                                    disabled={stripTagsFroala(item.value) === ''}
                                    onClick={() => {
                                        let tmpItem = { ...item }
                                        setItem({
                                            ...tmpItem,
                                            value: '',
                                            saved: tmpItem.value,
                                            opened: false,
                                        })
                                    }}
                                />
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(RedoItem)
